var chunkMapping = {
	"8776": [
		22948
	]
};
var idToExternalAndNameMapping = {
	"22948": [
		"default",
		"./router",
		39965
	]
};
var idToRemoteMap = {
	"22948": [
		{
			"externalType": "script",
			"name": "lk",
			"externalModuleId": 39965
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = function(chunkId, promises) {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}